import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.16671 15.8327H10.8334V12.3535L12.1667 13.6869L13.3334 12.4994L10 9.16602L6.66671 12.4994L7.85421 13.666L9.16671 12.3535V15.8327ZM5.00004 18.3327C4.54171 18.3327 4.14935 18.1695 3.82296 17.8431C3.49657 17.5167 3.33337 17.1244 3.33337 16.666V3.33268C3.33337 2.87435 3.49657 2.48199 3.82296 2.1556C4.14935 1.82921 4.54171 1.66602 5.00004 1.66602H11.6667L16.6667 6.66602V16.666C16.6667 17.1244 16.5035 17.5167 16.1771 17.8431C15.8507 18.1695 15.4584 18.3327 15 18.3327H5.00004ZM10.8334 7.49935H15L10.8334 3.33268V7.49935Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgUploadFile);
export default ForwardRef;
